import { streamingLoadTestOutcome } from './streamingLoadTestOutcome.js';

const feedback = ({ passed = false, failed = false, cancelled = false, warnings = [], failedChecks = [], incompleteReasons = [] }) => {
    const incomplete = !cancelled && !failed && !passed;
    const label = cancelled ? 'Encerrado' : failed ? 'Reprovado' : incomplete ? 'Inconclusivo'
        : passed ? warnings.length ? 'Aprovado com avisos' : 'Aprovado' : 'Inconclusivo';
    return {
        passed, failed, incomplete, cancelled,
        warnings, failedChecks, incompleteReasons, label,
        variant: failed ? 'danger' : passed && !warnings.length ? 'success' : 'primary',
        message: cancelled ? 'O teste foi encerrado. Os dados disponíveis são parciais e foram preservados para diagnóstico.'
            : failedChecks.length ? `A execução terminou com ${failedChecks.length} ${failedChecks.length === 1 ? 'validação reprovada' : 'validações reprovadas'}. As métricas foram preservadas para diagnóstico.`
                : failed ? 'O teste foi reprovado. Consulte as validações e os dados disponíveis abaixo.'
                    : passed ? warnings.length ? 'O teste foi aprovado com avisos. As validações obrigatórias foram confirmadas.'
                        : 'O teste foi aprovado. As validações obrigatórias foram confirmadas.'
                        : 'A execução terminou, mas faltam evidências para aprovar todas as validações.',
    };
};

export const streamingTestFeedback = (data = {}) => {
    const job = data.job || {};
    const report = data.report || job.result || {};
    const outcome = streamingLoadTestOutcome(job, report);
    const cancelled = job.status === 'cancelled';
    const policyStatus = report.chat_delivery_validation?.status;
    const failed = !cancelled && (outcome.failed || policyStatus === 'failed');
    const checkValues = Object.values(report.checks || {});
    // Older saved reports retained individual check verdicts before they retained
    // the aggregate passed flag. Completion alone never establishes approval.
    const recordedPass = report.passed === true || (report.passed !== false
        && (report.validation?.status === 'passed' || (checkValues.length > 0 && checkValues.every((value) => value === true))));
    const hls = report.hls_validation || job.metadata?.hls_validation;
    const warnings = [...new Set([...outcome.warnings, ...(Array.isArray(hls?.errors) ? hls.errors : [])])];
    const passed = !cancelled && !failed && !outcome.incomplete && policyStatus !== 'incomplete' && job.status === 'completed'
        && report.partial !== true && recordedPass;
    return feedback({ ...outcome, passed, failed, cancelled, warnings,
        failedChecks: outcome.failedChecks.length ? outcome.failedChecks : failed && policyStatus === 'failed' ? ['entrega e recuperação do chat'] : [],
        incompleteReasons: outcome.incompleteReasons.length ? outcome.incompleteReasons
            : !passed && !cancelled && !failed ? ['veredito final das validações'] : [],
    });
};

export const analyticsTestFeedback = (data = {}) => {
    const job = data.job || {};
    const report = data.report || job.result || {};
    const comparison = data.comparison || {};
    const runner = data.validation?.runner || comparison.runner_verdict || {};
    const dashboard = data.validation?.dashboard || comparison.dashboard_verdict || {};
    const cancelled = job.status === 'cancelled' || runner.status === 'cancelled';
    const failedTesterCheck = Object.values(report.checks || {}).includes(false);
    const incompleteTesterEvidence = report.validation?.status === 'incomplete' && !failedTesterCheck;
    const runnerFailed = !incompleteTesterEvidence && (job.status === 'failed' || runner.status === 'failed'
        || failedTesterCheck || report.validation?.status === 'failed' || (report.passed === false && report.partial !== true));
    const dashboardFailed = ['mismatch', 'contaminated', 'failed'].includes(dashboard.status);
    const failed = !cancelled && (runnerFailed || dashboardFailed);
    const passed = !cancelled && !failed && !incompleteTesterEvidence && job.status === 'completed' && report.partial !== true
        && runner.passed === true && dashboard.passed === true;
    const warnings = [...new Set(Array.isArray(report.warnings) ? report.warnings : [])];
    const failedChecks = failed ? [runnerFailed ? 'execução das jornadas dos bots' : null,
        dashboardFailed ? 'comparação dos dados analíticos' : null].filter(Boolean) : [];
    return feedback({ passed, failed, cancelled,
        warnings, failedChecks, incompleteReasons: !passed && !failed && !cancelled
            ? ['confirmação final dos dados analíticos no período do teste'] : [],
    });
};

export const redactLoadTestDiagnostic = (value) => {
    if (Array.isArray(value)) return value.map(redactLoadTestDiagnostic);
    if (!value || typeof value !== 'object') return value;
    return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key,
        /(?:api.?key|token|secret|password|authorization|emails?)/i.test(key)
            ? '[redacted]' : redactLoadTestDiagnostic(entry),
    ]));
};
